var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	(function(linkTag) {
	                if (typeof _N_E_STYLE_LOAD === 'function') {
	                    const { href, onload, onerror } = linkTag;
	                    _N_E_STYLE_LOAD(href.indexOf(window.location.origin) === 0 ? new URL(href).pathname : href).then(()=>onload == null ? void 0 : onload.call(linkTag, {
	                            type: 'load'
	                        }), ()=>onerror == null ? void 0 : onerror.call(linkTag, {}));
	                } else {
	                    document.head.appendChild(linkTag);
	                }
	            })(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	8068: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"35":1,"45":1,"112":1,"156":1,"347":1,"360":1,"397":1,"410":1,"440":1,"478":1,"500":1,"560":1,"688":1,"718":1,"840":1,"877":1,"892":1,"949":1,"1010":1,"1205":1,"1234":1,"1251":1,"1338":1,"1375":1,"1424":1,"1476":1,"1512":1,"1635":1,"1653":1,"1782":1,"1785":1,"1851":1,"1940":1,"1943":1,"2038":1,"2072":1,"2081":1,"2216":1,"2219":1,"2230":1,"2243":1,"2303":1,"2313":1,"2637":1,"2734":1,"2824":1,"2849":1,"2902":1,"2991":1,"3043":1,"3062":1,"3064":1,"3128":1,"3157":1,"3178":1,"3197":1,"3270":1,"3566":1,"3594":1,"3655":1,"3759":1,"3802":1,"3842":1,"3895":1,"3906":1,"3942":1,"4045":1,"4202":1,"4205":1,"4235":1,"4277":1,"4290":1,"4484":1,"4564":1,"4686":1,"4783":1,"4851":1,"5150":1,"5196":1,"5206":1,"5226":1,"5228":1,"5436":1,"5715":1,"5738":1,"5751":1,"5763":1,"5780":1,"5793":1,"5804":1,"5851":1,"5856":1,"5912":1,"6003":1,"6014":1,"6073":1,"6196":1,"6210":1,"6473":1,"6564":1,"6569":1,"6594":1,"6603":1,"6615":1,"6620":1,"6643":1,"6646":1,"6729":1,"6861":1,"6932":1,"6946":1,"6966":1,"7047":1,"7151":1,"7208":1,"7221":1,"7326":1,"7366":1,"7534":1,"7538":1,"7567":1,"7618":1,"7689":1,"7692":1,"7769":1,"7820":1,"7870":1,"7880":1,"7881":1,"7988":1,"8050":1,"8252":1,"8401":1,"8446":1,"8448":1,"8690":1,"8736":1,"8803":1,"8907":1,"8962":1,"9206":1,"9247":1,"9500":1,"9570":1,"9649":1,"9775":1,"9837":1,"9838":1,"9860":1,"9950":1,"9960":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr